import { render, staticRenderFns } from "./LoginModalFooter.vue?vue&type=template&id=c19feafe"
import script from "./LoginModalFooter.vue?vue&type=script&lang=ts"
export * from "./LoginModalFooter.vue?vue&type=script&lang=ts"
import style0 from "./LoginModalFooter.vue?vue&type=style&index=0&id=c19feafe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports